// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * reset
 */
body {
  font-family: "IBM Plex Sans",sans-serif;
  font-size: 14px;
}

a:link,
a:visited {
  color: var(--link-color);

  font-weight: bold;
  text-decoration: none;
}

a:hover,
a:focus {
  color: var(--link-color-hover);
}

/**
 * project logo
 */
.project-logo {
  margin: 50px auto;

  a {
    display: inline-block;
    height: 4em;
    width: auto;
    color: #404040;
    margin: 0 auto;

    svg {
      height: 100%;
    }
  }
}

.content,
.content > div {
  width: 100%;
  height: 100%;

  overflow: hidden;
}

.content > .screen {
  text-align: center;
  display: table;

  font-size: 16px;
}

.content > .screen .note {
  vertical-align: middle;
  text-align: center;
  display: table-cell;
}

.content .error {

  .details {
    max-width: 500px;
    font-size: 12px;
    margin: 20px auto;
    text-align: left;

    color: #BD2828;
  }

  .error-log {
    border: solid 1px hsl(0, 65%, 45%);
    background: hsl(0, 65%, 98%); /* lighten base by 53% */

    color: hsl(0, 65%, 45%);

    &:hover {
      background: hsl(0, 65%, 99%); /* lighten base by 54% */
    }
  }
}

body:not(.error) .screen.error,
body:not(.intro) .screen.intro,
body:not(.loading) .screen.loading {
  display: none;
}

body.loading,
body.intro {
  opacity: 0;
  transition: opacity 1s;

  &.animate {
    opacity: 1;
  }
}

.screen.loading {
  img {
    width: 48px;
  }
}

.canvas {
  display: block;
}

body.shown .canvas,
body.loaded .canvas {
  display: block;
}

body.loaded .canvas svg {
  visibility: hidden;
}


body:not(.shown) .io-export,
body:not(.shown) .io-zoom-controls {
  display: none;
}

/** front page / drop zone */

.samples,
.message {
  max-width: 700px;
  margin: 15px auto;
}

@media (max-width: 720px) {
  .samples,
  .message {
    margin: 20px;
  }

  .samples {
    margin-bottom: 60px;
  }
}

.message {
  font-size: 20px;
}

.samples {
  margin-top: 80px;
  margin-bottom: 60px;

  opacity: 0.4;
  transition: ease-in 0.1s;
}

.samples:hover {
  opacity: 1;
}

.samples .sample {
  display: inline-block;
  max-width: 100%;
  vertical-align: top;

  position: relative;
}

.samples .caption {
  font-size: 13px;
  font-weight: normal;
  color: #666;
}

.samples .img {
  border: solid 5px #E9E9E9;
  border-radius: 5px;
  padding: 5px;
  width: 100%;
}

.samples .sample > a {
  display: block;
}

/** widgets **/

.io-control {
  background: #FAFAFA;
  border-radius: 2px;
  border: solid 1px #E0E0E0;
  padding: 5px;
}

.cjs-powered-by,
.bjs-powered-by {
  padding-bottom: 2px;
}

.close {
  color: #333 !important;
  font-size: 21px;
  font-weight: 700 !important;
  opacity: .6;
  line-height: 1;
  vertical-align: middle;
  margin-left: 5px;
}

.close:hover {
  opacity: 1;
}

.io-control .vr {
  height: 15px;
  display: inline-block;
  border-right: solid 1px #DDD;
}

.io-control hr {
  border: none;
  border-top: solid 1px #DDD;
  width: 15px;
}

.io-control-list .vr {
  margin-right: 0;
}

.io-control-list {
  list-style: none;

  padding: 5px;
  margin: 0;

  a,
  a:visited,
  button {
    padding: 0;
    outline: none;

    cursor: pointer;
    font-size: 22px;
    line-height: 26px;

    color: var(--button-color);

    background: none;
    border: none;

    &:hover {
      color: var(--button-color-hover);
    }

    &.inactive {
      color: var(--button-color-inactive);
      cursor: default;
    }
  }

  &.io-horizontal,
  &.io-horizontal li {
    display: inline-block;
  }

  &.io-horizontal {

    li + li {
      margin-left: 10px;
    }

    a {
      padding: 2px;
    }
  }
}

.io-about {
  position: fixed;
  right: 10px;

  li + li {
    margin-left: 15px;
  }

}

body.shown .io-about {
  right: 90px;
}

.io-about a {
  font-size: 13px;
  line-height: 20px;
  font-weight: normal;
}

.io-about a:hover {
  background: #F0F0F0;
  border-radius: 2px;
}

.io-import-export {
  position: fixed;
  left: 10px;
}

.djs-palette {
  left: 10px !important;
  top: 10px !important;
}

.io-about {
  bottom: 8px;
}

.io-import-export {
  bottom: 10px;
}

.io-import {
  margin-right: 10px;
}

.io-zoom-controls {
  width: auto;
  position: fixed;
  right: 10px;
  bottom: 80px;
}

.io-editing-tools {
  width: auto;
  position: fixed;
  right: 5px;
  top: 5px;

  display: none;

  .io-control {
    margin-left: 10px;

    button {
      margin: 0;
    }
  }
}

.io-zoom-reset {
  margin-bottom: 10px;
}

.io-import-export .inactive {
  opacity: 0.3;
}


/**
 * import warnings dialog
 */
.import-warnings {
  .error-log {
    width: 100%;
  }
}

/**
 * utilities
 */

.hidden {
  display: none;
}

/**
 * alerts
 */
.io-alerts {
  position: fixed;
  top: 10px;
  width: var(--alert-width);
  text-align: center;
  left: 50%;
  margin-left: calc(var(--alert-width) / -2);

  .alert {
    display: none;
    background: #eeefdf;

    padding: 10px 20px;

    line-height: 20px;
    margin: 0 auto 10px;

    &.open {
      display: inline-flex;
    }
  }
}

.io-toggle-fullscreen {
  display: none;

  &.open {
    display: inline-block;
  }
}


/* --alert-width (450px) + 50 */
@media (max-width: 500px) {
  .io-alerts {
    width: 100%;
    text-align: center;
    left: 0;
    margin: 0;
  }
}


/**
 * dialogs
 */
.io-dialog {
  display: none;

  &.open {
    display: block;
  }

  &.open:before {
    content: '';
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;

    background: #666;
    opacity: 0.2;

    z-index: 1001;
  }

  .content {
    position: fixed;

    width: var(--dialog-width);
    left: 50%;
    transform: translateX(-50%);
    top: 100px;

    background: white;
    padding: 10px 30px 20px 30px;

    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 2px;

    height: auto;

    z-index: 1001;
  }

}

.keybindings-dialog {

  .content {
    width: var(--alert-width);
    margin-left: calc(var(--alert-width) / -2);
  }

  .binding {
    padding: 5px 10px;
    font-family: monospace;
  }
}

textarea.error-log {
  border: solid 1px #CCC;
  background: hsl(0, 0%, 96%);
  padding: 10px;

  margin: 10px auto;

  width: 100%;

  min-height: 150px;

  display: block;

  &:hover {
    background: hsl(0, 0%, 97%); /* lighten base by 1% */
  }
}

/* --dialog-width (600px) */
@media (max-width: 600px) {
  .io-dialog .content {
    left: 20px;
    right: 20px;
    top: 20px;
    width: auto;

    margin: 0;
  }
}


.spinner-border {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: white;
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes spinner-keyframe {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner-border:after {
  width: 22px;
  height: 22px;
  border: 4px solid var(--loader-color);
  content: " ";
  display: block;
  border-radius: 50%;
  border-color: var(--loader-color) var(--loader-color) var(--loader-color) transparent;
  animation: spinner-keyframe 0.7s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./client/css/style.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,uCAAuC;EACvC,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;;EAExB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE;AACF;EACE,iBAAiB;;EAEjB;IACE,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,cAAc;IACd,cAAc;;IAEd;MACE,YAAY;IACd;EACF;AACF;;AAEA;;EAEE,WAAW;EACX,YAAY;;EAEZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;;IAEhB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,4BAA4B,EAAE,wBAAwB;;IAEtD,uBAAuB;;IAEvB;MACE,4BAA4B,EAAE,wBAAwB;IACxD;EACF;AACF;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,sBAAsB;;EAEtB;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;;EAEE,aAAa;AACf;;AAEA,4BAA4B;;AAE5B;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;;IAEE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;;EAEnB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;;EAEnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;;AAEd;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;;EAEhB,YAAY;EACZ,SAAS;;EAET;;;IAGE,UAAU;IACV,aAAa;;IAEb,eAAe;IACf,eAAe;IACf,iBAAiB;;IAEjB,0BAA0B;;IAE1B,gBAAgB;IAChB,YAAY;;IAEZ;MACE,gCAAgC;IAClC;;IAEA;MACE,mCAAmC;MACnC,eAAe;IACjB;EACF;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE;MACE,iBAAiB;IACnB;;IAEA;MACE,YAAY;IACd;EACF;AACF;;AAEA;EACE,eAAe;EACf,WAAW;;EAEX;IACE,iBAAiB;EACnB;;AAEF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,QAAQ;;EAER,aAAa;;EAEb;IACE,iBAAiB;;IAEjB;MACE,SAAS;IACX;EACF;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;;AAGA;;EAEE;AACF;EACE;IACE,WAAW;EACb;AACF;;AAEA;;EAEE;;AAEF;EACE,aAAa;AACf;;AAEA;;EAEE;AACF;EACE,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,0CAA0C;;EAE1C;IACE,aAAa;IACb,mBAAmB;;IAEnB,kBAAkB;;IAElB,iBAAiB;IACjB,mBAAmB;;IAEnB;MACE,oBAAoB;IACtB;EACF;AACF;;AAEA;EACE,aAAa;;EAEb;IACE,qBAAqB;EACvB;AACF;;;AAGA,+BAA+B;AAC/B;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;EACX;AACF;;;AAGA;;EAEE;AACF;EACE,aAAa;;EAEb;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;;IAER,gBAAgB;IAChB,YAAY;;IAEZ,aAAa;EACf;;EAEA;IACE,eAAe;;IAEf,0BAA0B;IAC1B,SAAS;IACT,2BAA2B;IAC3B,UAAU;;IAEV,iBAAiB;IACjB,4BAA4B;;IAE5B,wCAAwC;IACxC,kBAAkB;;IAElB,YAAY;;IAEZ,aAAa;EACf;;AAEF;;AAEA;;EAEE;IACE,yBAAyB;IACzB,0CAA0C;EAC5C;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;;EAEb,iBAAiB;;EAEjB,WAAW;;EAEX,iBAAiB;;EAEjB,cAAc;;EAEd;IACE,2BAA2B,EAAE,uBAAuB;EACtD;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,WAAW;IACX,SAAS;IACT,WAAW;;IAEX,SAAS;EACX;AACF;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,qFAAqF;EACrF,gDAAgD;AAClD","sourcesContent":["/**\n * reset\n */\nbody {\n  font-family: \"IBM Plex Sans\",sans-serif;\n  font-size: 14px;\n}\n\na:link,\na:visited {\n  color: var(--link-color);\n\n  font-weight: bold;\n  text-decoration: none;\n}\n\na:hover,\na:focus {\n  color: var(--link-color-hover);\n}\n\n/**\n * project logo\n */\n.project-logo {\n  margin: 50px auto;\n\n  a {\n    display: inline-block;\n    height: 4em;\n    width: auto;\n    color: #404040;\n    margin: 0 auto;\n\n    svg {\n      height: 100%;\n    }\n  }\n}\n\n.content,\n.content > div {\n  width: 100%;\n  height: 100%;\n\n  overflow: hidden;\n}\n\n.content > .screen {\n  text-align: center;\n  display: table;\n\n  font-size: 16px;\n}\n\n.content > .screen .note {\n  vertical-align: middle;\n  text-align: center;\n  display: table-cell;\n}\n\n.content .error {\n\n  .details {\n    max-width: 500px;\n    font-size: 12px;\n    margin: 20px auto;\n    text-align: left;\n\n    color: #BD2828;\n  }\n\n  .error-log {\n    border: solid 1px hsl(0, 65%, 45%);\n    background: hsl(0, 65%, 98%); /* lighten base by 53% */\n\n    color: hsl(0, 65%, 45%);\n\n    &:hover {\n      background: hsl(0, 65%, 99%); /* lighten base by 54% */\n    }\n  }\n}\n\nbody:not(.error) .screen.error,\nbody:not(.intro) .screen.intro,\nbody:not(.loading) .screen.loading {\n  display: none;\n}\n\nbody.loading,\nbody.intro {\n  opacity: 0;\n  transition: opacity 1s;\n\n  &.animate {\n    opacity: 1;\n  }\n}\n\n.screen.loading {\n  img {\n    width: 48px;\n  }\n}\n\n.canvas {\n  display: block;\n}\n\nbody.shown .canvas,\nbody.loaded .canvas {\n  display: block;\n}\n\nbody.loaded .canvas svg {\n  visibility: hidden;\n}\n\n\nbody:not(.shown) .io-export,\nbody:not(.shown) .io-zoom-controls {\n  display: none;\n}\n\n/** front page / drop zone */\n\n.samples,\n.message {\n  max-width: 700px;\n  margin: 15px auto;\n}\n\n@media (max-width: 720px) {\n  .samples,\n  .message {\n    margin: 20px;\n  }\n\n  .samples {\n    margin-bottom: 60px;\n  }\n}\n\n.message {\n  font-size: 20px;\n}\n\n.samples {\n  margin-top: 80px;\n  margin-bottom: 60px;\n\n  opacity: 0.4;\n  transition: ease-in 0.1s;\n}\n\n.samples:hover {\n  opacity: 1;\n}\n\n.samples .sample {\n  display: inline-block;\n  max-width: 100%;\n  vertical-align: top;\n\n  position: relative;\n}\n\n.samples .caption {\n  font-size: 13px;\n  font-weight: normal;\n  color: #666;\n}\n\n.samples .img {\n  border: solid 5px #E9E9E9;\n  border-radius: 5px;\n  padding: 5px;\n  width: 100%;\n}\n\n.samples .sample > a {\n  display: block;\n}\n\n/** widgets **/\n\n.io-control {\n  background: #FAFAFA;\n  border-radius: 2px;\n  border: solid 1px #E0E0E0;\n  padding: 5px;\n}\n\n.cjs-powered-by,\n.bjs-powered-by {\n  padding-bottom: 2px;\n}\n\n.close {\n  color: #333 !important;\n  font-size: 21px;\n  font-weight: 700 !important;\n  opacity: .6;\n  line-height: 1;\n  vertical-align: middle;\n  margin-left: 5px;\n}\n\n.close:hover {\n  opacity: 1;\n}\n\n.io-control .vr {\n  height: 15px;\n  display: inline-block;\n  border-right: solid 1px #DDD;\n}\n\n.io-control hr {\n  border: none;\n  border-top: solid 1px #DDD;\n  width: 15px;\n}\n\n.io-control-list .vr {\n  margin-right: 0;\n}\n\n.io-control-list {\n  list-style: none;\n\n  padding: 5px;\n  margin: 0;\n\n  a,\n  a:visited,\n  button {\n    padding: 0;\n    outline: none;\n\n    cursor: pointer;\n    font-size: 22px;\n    line-height: 26px;\n\n    color: var(--button-color);\n\n    background: none;\n    border: none;\n\n    &:hover {\n      color: var(--button-color-hover);\n    }\n\n    &.inactive {\n      color: var(--button-color-inactive);\n      cursor: default;\n    }\n  }\n\n  &.io-horizontal,\n  &.io-horizontal li {\n    display: inline-block;\n  }\n\n  &.io-horizontal {\n\n    li + li {\n      margin-left: 10px;\n    }\n\n    a {\n      padding: 2px;\n    }\n  }\n}\n\n.io-about {\n  position: fixed;\n  right: 10px;\n\n  li + li {\n    margin-left: 15px;\n  }\n\n}\n\nbody.shown .io-about {\n  right: 90px;\n}\n\n.io-about a {\n  font-size: 13px;\n  line-height: 20px;\n  font-weight: normal;\n}\n\n.io-about a:hover {\n  background: #F0F0F0;\n  border-radius: 2px;\n}\n\n.io-import-export {\n  position: fixed;\n  left: 10px;\n}\n\n.djs-palette {\n  left: 10px !important;\n  top: 10px !important;\n}\n\n.io-about {\n  bottom: 8px;\n}\n\n.io-import-export {\n  bottom: 10px;\n}\n\n.io-import {\n  margin-right: 10px;\n}\n\n.io-zoom-controls {\n  width: auto;\n  position: fixed;\n  right: 10px;\n  bottom: 80px;\n}\n\n.io-editing-tools {\n  width: auto;\n  position: fixed;\n  right: 5px;\n  top: 5px;\n\n  display: none;\n\n  .io-control {\n    margin-left: 10px;\n\n    button {\n      margin: 0;\n    }\n  }\n}\n\n.io-zoom-reset {\n  margin-bottom: 10px;\n}\n\n.io-import-export .inactive {\n  opacity: 0.3;\n}\n\n\n/**\n * import warnings dialog\n */\n.import-warnings {\n  .error-log {\n    width: 100%;\n  }\n}\n\n/**\n * utilities\n */\n\n.hidden {\n  display: none;\n}\n\n/**\n * alerts\n */\n.io-alerts {\n  position: fixed;\n  top: 10px;\n  width: var(--alert-width);\n  text-align: center;\n  left: 50%;\n  margin-left: calc(var(--alert-width) / -2);\n\n  .alert {\n    display: none;\n    background: #eeefdf;\n\n    padding: 10px 20px;\n\n    line-height: 20px;\n    margin: 0 auto 10px;\n\n    &.open {\n      display: inline-flex;\n    }\n  }\n}\n\n.io-toggle-fullscreen {\n  display: none;\n\n  &.open {\n    display: inline-block;\n  }\n}\n\n\n/* --alert-width (450px) + 50 */\n@media (max-width: 500px) {\n  .io-alerts {\n    width: 100%;\n    text-align: center;\n    left: 0;\n    margin: 0;\n  }\n}\n\n\n/**\n * dialogs\n */\n.io-dialog {\n  display: none;\n\n  &.open {\n    display: block;\n  }\n\n  &.open:before {\n    content: '';\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n\n    background: #666;\n    opacity: 0.2;\n\n    z-index: 1001;\n  }\n\n  .content {\n    position: fixed;\n\n    width: var(--dialog-width);\n    left: 50%;\n    transform: translateX(-50%);\n    top: 100px;\n\n    background: white;\n    padding: 10px 30px 20px 30px;\n\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n    border-radius: 2px;\n\n    height: auto;\n\n    z-index: 1001;\n  }\n\n}\n\n.keybindings-dialog {\n\n  .content {\n    width: var(--alert-width);\n    margin-left: calc(var(--alert-width) / -2);\n  }\n\n  .binding {\n    padding: 5px 10px;\n    font-family: monospace;\n  }\n}\n\ntextarea.error-log {\n  border: solid 1px #CCC;\n  background: hsl(0, 0%, 96%);\n  padding: 10px;\n\n  margin: 10px auto;\n\n  width: 100%;\n\n  min-height: 150px;\n\n  display: block;\n\n  &:hover {\n    background: hsl(0, 0%, 97%); /* lighten base by 1% */\n  }\n}\n\n/* --dialog-width (600px) */\n@media (max-width: 600px) {\n  .io-dialog .content {\n    left: 20px;\n    right: 20px;\n    top: 20px;\n    width: auto;\n\n    margin: 0;\n  }\n}\n\n\n.spinner-border {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: white;\n  z-index: 200;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@keyframes spinner-keyframe {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.spinner-border:after {\n  width: 22px;\n  height: 22px;\n  border: 4px solid var(--loader-color);\n  content: \" \";\n  display: block;\n  border-radius: 50%;\n  border-color: var(--loader-color) var(--loader-color) var(--loader-color) transparent;\n  animation: spinner-keyframe 0.7s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
